module.exports = require("/Users/david/Sites/freelance/custom-fit/build/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 374
// module chunks = 231608221292675